import Service, { getCallApiFunction } from '../service'
import denormalizer from './denormalizer'
// import normalizer from './normalizer'

class FetchThemeListApi extends Service {
  constructor() {
    super()
    this.name = 'FETCH_THEME_LIST'

    this.config = {
      url: `/v1/product/theme-halls`,
      method: 'GET',
    }

    this.denormalizer = denormalizer
  }
}

export const fetchThemeList = () => getCallApiFunction(new FetchThemeListApi())
